<template>
  <div>

    <!-- page banner -->
    <page-banner
      :title="$t('payment.upgrades')"
      :subTitle="$t('payment.confirm_booking')"
      :promoBox="false"
      :payment="true"
    />

    <div class="main-area container style02">
      <div class="main-holder">
        <div class="row">
          <div class="col-lg-8 col-12">
            <div class="suggestion-area">

              <h2>{{ $t('payment.basket.recommended') }}</h2>

              <div class="suggestion-holder">
 
                <!-- lounge list -->
                <div v-if="upgrades.products.airportlounge && upgrades.products.airportlounge.length > 0 && quote">
                  <addon-item-lounge
                    v-for="(product, key) in upgrades.products.airportlounge" 
                    :key="key"
                    :product="product"
                    :airport="results.airport"
                  />
                </div>
              </div>
              <!-- <div class="checkbox-block">
                <input type="checkbox" id="checkbox05">
                <label for="checkbox05">
                  <strong class="title">Security FastTrack - £5.00 per person</strong>
                  <span class="text">Save time queuing and take the fast track through security - you'll even save money when you book the tickets in advance through us.</span>
                </label>
              </div> -->
            </div>
          </div>
          <div class="col-lg-4 col-12">

            <!-- basket -->
            <basket v-if="!emptyCart && quote" :upgrade="true" />
          </div>
        </div>
      </div>
    </div>

    <!-- timeout modal -->
    <timeout />

    <!-- more info -->
    <more-info />

  </div>
</template>

<script>
import { sync, get, call } from "vuex-pathify";
import { eventBus } from "@/eventBus";
import mixins from "@/mixins";
import { PageBanner, Timeout, Basket, MoreInfo, AddonItemLounge } from "@/components";

export default {
  name: 'cross-selling',
  components: { PageBanner, Timeout, Basket, MoreInfo, AddonItemLounge },
  mixins: [mixins.load, mixins.format, mixins.pageview],
  computed: {
    quote: get("quote"),
    cart: get("cart/products"),
    payment: sync("payment"),
    airport: get("results/airport"),
    title: get("cart/title"),
    emptyCart: get("cart/emptyCart"),
    upgrades: get("upgrades"),
    results: get("results"),
    moreInfo: sync("modals/moreInfo"),
  },
  methods: {
    addToCart: call("cart/addToCart"),
    totalCart: call('cart/totalCart'),
  },
  mounted() {
    this.totalCart()
    this.sendPageView()

    eventBus.$once("SELECTED", value => {
      if(value.category === 'airportlounge') this.needVehicle = false;
      
      this.addToCart({ upgrade: true, category: 'airportlounge', ...value }).then(() => {
        this.moreInfo = false
        this.$router.push('/payment', () => {});
      });
    });
  }
};
</script>